<template>
    <b-button class="rounded-0 me-1" @click="isOpen3 = true" variant="primary">
        <i v-if="loading" class="fa fa-hourglass fa-spin"></i>
        <i v-else class="fa fa-sync"></i>
    </b-button>
    <b-modal v-model="isOpen3" id="modal-sm" size="sm" title="Select Filter To Sync Data" title-class="font-18" hide-footer>
        <b-row>
            <b-col md="12" class="p-1" v-if="componentName == 'orders'">
                <b-form-group label="Select Type" label-for="order-status">
                    <b-form-select 
                        v-model="selectedType" 
                        :options="syncingTypes" 
                        class="mb-2" 
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="12" class="p-1">
                <b-form-group label="Select Date Range" label-for="order-status">
                    <b-form-select 
                        v-model="selectedRange" 
                        :options="dateRanges" 
                        class="mb-2" 
                        @change="setDateRange"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="12" class="p-1" v-if="selectedRange == 'custom'">
                <b-form-group label="Customize Date Range" label-for="order-status">
                    <custom-date-range
                    @set-date="setDate"
                    ></custom-date-range>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="text-end">
              <div class="button-group">
                <b-button @click="submitSync" variant="primary">Start Syncing {{ componentTitle }}</b-button>
              </div>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
export default {
    props: {
        componentName: {
            type: String,
            default: '',
        },
        componentTitle: {
            type: String,
            default: '',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen3: false,
            dateRange: [],
            selectedType:'orders',
            selectedRange: 'today',
            dateRanges: [
                { value: 'today', text: 'Today' },
                { value: 'yesterday', text: 'Yesterday' },
                { value: 'this_week', text: 'This Week' },
                { value: 'last_7_days', text: 'Last Week' },
                { value: 'this_month', text: 'This Month' },
                { value: 'last_month', text: 'Last Month' },
                { value: 'this_year', text: 'This Year' },
                // { value: 'last_30_days', text: 'Last 30 Days' },
                // { value: 'last_90_days', text: 'Last 90 Days' },
                // { value: 'last_6_months', text: 'Last 6 Months' },
                // { value: 'last_year', text: 'Last Year' },
                { value: 'custom', text: 'Custom Range' },
            ],
            syncingTypes: [
                { value: 'orders', text: 'Orders' },
                { value: 'order-statuses', text: 'Order statuses' },
            ],
        };
    },
    computed:{
        loading(){
            return this.isLoading;
        }
    },
    created(){
        this.dateRange = [this.getFormattedDate(0), this.getFormattedDate(0)];
    },
    methods: {
        setDate(dates){
            this.dateRange.push(dates.start_date,dates.end_date);
        },
        submitSync() {
            // Emit the updated perPage value to the parent component
            this.$emit('call-sync-'+this.componentName, this.dateRange, this.selectedType);
            this.isOpen3 = false;
        },
        getFormattedDate(offsetDays = 0) {
            let date = new Date();
            date.setDate(date.getDate() + offsetDays);
            return date.toISOString().split("T")[0];
        },
        getFirstDayOfMonth(offsetMonths = 0) {
            let date = new Date();
            date.setMonth(date.getMonth() + offsetMonths, 1);
            return date.toISOString().split("T")[0];
        },
        getLastDayOfMonth(offsetMonths = 0) {
            let date = new Date();
            date.setMonth(date.getMonth() + offsetMonths + 1, 0);
            return date.toISOString().split("T")[0];
        },
        getFirstDayOfYear(offsetYears = 0) {
            let date = new Date();
            date.setFullYear(date.getFullYear() + offsetYears, 0, 1);
            return date.toISOString().split("T")[0];
        },
        getLastDayOfYear(offsetYears = 0) {
            let date = new Date();
            date.setFullYear(date.getFullYear() + offsetYears, 11, 31);
            return date.toISOString().split("T")[0];
        },
        setDateRange(val) {
            switch (val) {
                case 'today':
                    this.dateRange = [this.getFormattedDate(0), this.getFormattedDate(0)];
                    break;
                case 'yesterday':
                    this.dateRange = [this.getFormattedDate(-1), this.getFormattedDate(-1)];
                    break;
                case 'this_week':{
                    let startOfWeek = new Date();
                    startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay()); // Sunday
                    this.dateRange = [startOfWeek.toISOString().split("T")[0], this.getFormattedDate(0)];
                    break;
                }
                case 'this_month':
                    this.dateRange = [this.getFirstDayOfMonth(0), this.getLastDayOfMonth(0)];
                    break;
                case 'last_month':
                    this.dateRange = [this.getFirstDayOfMonth(-1), this.getLastDayOfMonth(-1)];
                    break;
                case 'this_year':
                    this.dateRange = [this.getFirstDayOfYear(0), this.getLastDayOfYear(0)];
                    break;
                case 'last_7_days':
                    this.dateRange = [this.getFormattedDate(-7), this.getFormattedDate(0)];
                    break;
                case 'last_30_days':
                    this.dateRange = [this.getFormattedDate(-30), this.getFormattedDate(0)];
                    break;
                case 'last_90_days':
                    this.dateRange = [this.getFormattedDate(-90), this.getFormattedDate(0)];
                    break;
                case 'last_6_months':{
                    let lastSixMonths = new Date();
                    lastSixMonths.setMonth(lastSixMonths.getMonth() - 6);
                    this.dateRange = [lastSixMonths.toISOString().split("T")[0], this.getFormattedDate(0)];
                    break;
                }
                case 'last_year':
                    this.dateRange = [this.getFirstDayOfYear(-1), this.getLastDayOfYear(-1)];
                    break;
                case 'custom':
                    this.dateRange = [];
                    break;
            }
        },

    }
};
</script>